import React, { useState } from "react";
import Events from "components/Events";
import ActiveLocationContext from "hooks/active-location-context";
import InfoBoxContext from "hooks/info-box-context";

const EventsWithContext = (props) => {
  const [showInfoBox, setShowInfoBox] = useState(false);
  const infoBoxStatus = { showInfoBox, setShowInfoBox };

  // Context for the info box location info
  const [activeLocationId, setActiveLocationId] = useState(false);
  const activeLocation = { activeLocationId, setActiveLocationId };
  return (
    <InfoBoxContext.Provider value={infoBoxStatus}>
      <ActiveLocationContext.Provider value={activeLocation}>
        <Events {...props} />{" "}
      </ActiveLocationContext.Provider>
    </InfoBoxContext.Provider>
  );
};

export default EventsWithContext;
